export default __webpack_public_path__ + "static/PromptIconFive-3494b81167eadc2c7bde81c79d2ebda1.png";